import type { WasteFacility } from 'portal/store/interfaces'

export const FACILITIES_LOAD = 'FACILITIES_LOAD'
export const facilitiesLoad = (
  hint: string | null,
  removalDate: string | null
): facilitiesLoadAction => ({
  type: FACILITIES_LOAD,
  hint: hint,
  removalDate: removalDate
})

export const FACILITIES_LOAD_CONTINUATION = 'FACILITIES_LOAD_CONTINUATION'
export const facilitiesLoadContinuation = (
  hint: string | null,
  removalDate: string | null,
  continuationToken: string | null
): facilitiesLoadContinuationAction => ({
  type: FACILITIES_LOAD_CONTINUATION,
  hint: hint,
  removalDate: removalDate,
  continuationToken: continuationToken
})

export const FACILITIES_LOAD_SUCCESS = 'FACILITIES_LOAD_SUCCESS'
export const facilitiesLoadSuccess = (
  facilities: WasteFacility[],
  continuationToken: string,
  hasNextPage: boolean
): facilitiesLoadSuccessAction => ({
  type: FACILITIES_LOAD_SUCCESS,
  facilities,
  continuationToken,
  hasNextPage
})

export const FACILITIES_LOAD_FAIL = 'FACILITIES_LOAD_FAIL'
export const facilitiesLoadFailure = (error): facilitiesLoadFailAction => ({
  type: FACILITIES_LOAD_FAIL,
  error
})

// INTERFACEs

export interface facilitiesLoadAction {
  type: typeof FACILITIES_LOAD
  hint: string | null
  removalDate: string | null
}

export interface facilitiesLoadContinuationAction {
  type: typeof FACILITIES_LOAD_CONTINUATION
  hint: string | null
  continuationToken: string | null
  removalDate: string | null
}

interface facilitiesLoadSuccessAction {
  type: typeof FACILITIES_LOAD_SUCCESS
  facilities: WasteFacility[]
  continuationToken: string | null
  hasNextPage: boolean
}

interface facilitiesLoadFailAction {
  type: typeof FACILITIES_LOAD_FAIL
  error: any
}
